import { NeutPosition } from "../../neuten/neut/neut-position";
import { SluitpotPosition } from "../../sluitpot/sluitpot-position";

export interface SluitpotModel {
  sluitpotCode?: string;
  omschrijving?: string;
  maat?: number;
  maat2?: number;
  isNonBlinde?: boolean;
}

export class SluitpotUtils {
  public static isInDeDam(omschrijving: string): boolean {
    return omschrijving.toLowerCase().indexOf(SluitpotPosition.Dam) !== -1;
  }

  public static isInDeSponning(omschrijving: string): boolean {
    return omschrijving.toLowerCase().indexOf(SluitpotPosition.Sponning) !== -1
        || omschrijving.toLowerCase().indexOf(SluitpotPosition.Sponning2) !== -1;
  }

  public static isNonBlindeSluitpott(omschrijving: string): boolean {
    return omschrijving?.toLowerCase().indexOf("blind") === -1;
  }
}